/******************************************************************************
//
//
//
//  #AGE GATE
//
//
//
******************************************************************************/

var AgeGate = (function() {
    var ageGate = document.querySelector('.c-age-gate');
    var ageGateButtonApprove = document.querySelector('.js-age-gate-approve');
    var html = document.documentElement;

    var _addEventListeners = function() {
        ageGateButtonApprove.addEventListener('click', function() {
            Cookies.set('ciwc-age-gate', 'verified', { expires: 7 });

            _hideAgeGate();
        });
    };

    var _checkPermission = function() {
        var age = Cookies.get('ciwc-age-gate');

        if(age === 'verified') {
            _hideAgeGate();
        } else {
            _showAgeGate();
        }
    };

    var _hideAgeGate = function() {
        ageGate.classList.remove('is-active');
        html.classList.remove('is-disable-scroll');
    };

    var _showAgeGate = function() {
        _addEventListeners();

        ageGate.classList.add('is-active');
        html.classList.add('is-disable-scroll');
    };

    var init = function() {
        _checkPermission();
    };

    return { init: init };
})();
